(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-page-contact"] && !Shopify.designMode) return;
  try {
    
function initEditableCallback() {
  document.querySelectorAll('[data-ogc-callback-date]').forEach((input) => {
    const update = () => {
      const parts = new Intl.DateTimeFormat('en', {timeZone:'Europe/Copenhagen',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const v = type => Number(parts.find(p => p.type === type).value);
      input.min = new Date(Date.UTC(v('year'),v('month')-1,v('day')+1)).toISOString().slice(0,10);
    };
    update();
    if (!input.dataset.initialized) {
      input.addEventListener('focus', update);
      input.form.addEventListener('submit', event => { update(); if (!input.checkValidity()) {event.preventDefault(); input.reportValidity();} });
      input.dataset.initialized = 'true';
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initEditableCallback);
else initEditableCallback();
document.addEventListener('shopify:section:load', initEditableCallback);

  } catch(e) { console.error(e); }
})();
})();
